<style>
@import url('https://fonts.googleapis.com/css2?family=Montserrat:wght@800&display=swap');

.img-hero-results {
  background-size: cover;
  background-repeat: no-repeat;
  height: 500px;
  width: 100%;
  margin-top:30px;
}

.top-title-res {
  display: flex;
  flex-direction: column;
  width: 100%;
  margin-top: 270px;
  z-index: 50;
}

.top-title-res small {
  cursor: pointer;
}

.big-title {
  font-weight: 100;
  font-size: 64px;
  color: #3D4053;
  font-family: "Montserrat";
}
.small-title {
  font-weight: 600;
  color: #3D4053;
  font-family: "Montserrat";
}

.retailers-results {
  display: flex;
  justify-content: start;
  flex-direction: column;
  position: relative;
  margin-top: 50px;
  margin-bottom: 50px;
  width: 100%;
}

.retailers-results .result-title {
  font-family: "Montserrat";
  letter-spacing: 0px;
  color: #3D4053;
  font-size: 30px;
  width: 100%;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  flex-direction: row;
  align-items: center;
  align-content: center;
  justify-content: space-evenly;
  text-transform:capitalize;
}

.btn-demo {
  color: #fff;
  background: linear-gradient(267.53deg, #FF3CA5 0%, #CA74FF 100%);
  height: 60px;
  border: none;
  border-radius: 4px;
  width: 300px;
  font-weight: bold;
  font-size: 33px;
  cursor: pointer;
  font-family: "Montserrat";
  box-shadow: 0px 100px 80px rgba(0, 0, 0, 0.0196802), 
  0px 41.7776px 33.4221px rgba(0, 0, 0, 0.0282725), 
  0px 22.3363px 17.869px rgba(0, 0, 0, 0.035), 
  0px 12.5216px 10.0172px rgba(0, 0, 0, 0.0417275), 
  0px 6.6501px 5.32008px rgba(0, 0, 0, 0.0503198), 
  0px 2.76726px 2.21381px rgba(0, 0, 0, 0.07);
}

.retailers-results .res-influencers {
  width: 100%;
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  align-items: center;
  align-content: center;
  margin-top: 30px;
  margin-bottom: 30px;
}

.retailers-results .result-cards {
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
  align-content: center;
  margin-top: 30px;
  margin-bottom: 30px;
}

.retailers-results-wait {
  display: flex;
  justify-content: center;
  position: relative;
  margin-top: 15px;
  margin-bottom: 15px;
  width: 100%;
}

.retailers-results-wait img {
  height: 375px;
  width: 375px;
}

.btn-bottom {
  margin-top: 30px;
  margin-bottom: 30%;
  display: flex;
  width: 100%;
  -webkit-box-align: end;
  -ms-flex-align: end;
  align-items: end;
  align-content: end;
  justify-content: center;
}

.btn-bottom-demo {
  color: #000;
  background: linear-gradient(267.53deg, #FF3CA5 0%, #CA74FF 100%);
  color:#fff;
  height: 64px;
  border: none;
  border-radius: 17px;
  width: 286px;
  font-weight: 700;
  font-size: 25px;
  cursor: pointer;
  font-family: "Montserrat";
  text-transform: uppercase;
  box-shadow: 0px 100px 80px rgba(0, 0, 0, 0.0196802), 
  0px 41.7776px 33.4221px rgba(0, 0, 0, 0.0282725), 
  0px 22.3363px 17.869px rgba(0, 0, 0, 0.035), 
  0px 12.5216px 10.0172px rgba(0, 0, 0, 0.0417275), 
  0px 6.6501px 5.32008px rgba(0, 0, 0, 0.0503198), 
  0px 2.76726px 2.21381px rgba(0, 0, 0, 0.07);
}

@media only screen and (max-width: 768px) {
  .img-hero-results {
    background-size: contain;
    background-repeat: no-repeat;
    height: 300px;
    width: 100%;
  }

  .big-title {
    font-size: 30px;
  }

  .small-title {
    font-size: 25px;
    padding-top: 15px;
    padding-bottom: 15px;
    height: 100px;
    display: flex;
    justify-content: center;
    align-items: center;
    height: 120px;
  }
  .retailers-results .result-title {
    font-size: 20px;
    justify-content: center;
    align-items: center;
    flex-direction: column;
  }

  .btn-demo {
    color: #000;
    background-color: #57f3bb;
    height: 40px;
    border: none;
    border-radius: 4px;
    width: 250px;
    font-weight: bold;
    font-size: 18px;
    cursor: pointer;
    margin-top: 15px;
  }
}
</style>

<template>
  <div>
    <MainMenu />
    <div class="container">
      <div class="container">
        <div class="top-title-res">
          <h1 class="big-title">Congratulations {{ user.retailers.fullname }}</h1>
          <h2 class="small-title">We found {{ user.result.data.total.value }} influencers</h2>
          <small @click="redirectToSearch"><u>change search requirements</u></small>
        </div>

        <div v-if="user.result.data" class="retailers-results">
          <div class="result-title">
            <span>
              Here Are Your Search Results
            </span>
          </div>

          <div class="res-influencers">
            <div class="row">
              <div
                class="col-xl-4 col-lg-4 col-md-6 col-xs-12"
                v-for="item in user.result.data.hits.slice(0, 24)"
                :key="item.id"
              >
                <Card v-bind:result="item" />
              </div>
            </div>
          </div>

          <div class="btn-bottom">
            <button class="btn-bottom-demo" @click="redirectProfile">
              More results 
            </button>
          </div>
        </div>
        <div v-else class="retailers-results-wait">
          <img src="../assets/gifSearch.gif" class="gif" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import router from "../router.js";
import { mapState, mapActions } from "vuex";

import MainMenu from "../components/MainMenu";
import Card from "../components/Card";

export default {
  name: "RetailersResults",
  data() {
    return {};
  },
  components: {
    MainMenu,
    Card,
  },
  computed: mapState(["user"]),

  methods: {
    redirectProfile: function() {
      router.push({ name: "RetailersBook" });
    },
    redirectToSearch: function() {
      router.push({ name: "RetailersSearch"})
    }
  },
  mounted() {
    this.$store.dispatch("getSearchResult");
  },
};
</script>
